
import XAPPService from "app/Core/services/XAPPService";
export const GET_ALERTAS = "[ALERTAS APP] GET ALERTAS";
export const ALERTAS_ERROR = "[ALERTAS APP] ALERTAS ERROR";
export const ALERTAS_CHANGE_PRELOAD = "[ALERTAS APP] CHANGE PRELOAD";

export function list(_AAction, _AParams, _AConditions) {

    return (dispatch) => {
        dispatch(changePreload());
        var AConditionsAND = [
            { "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AConditions.idpessoaformulario },
            { "Campo": "idfontepagadora", "Operador": "=", "Valor": _AConditions.idfontepagadora }
        ];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "AgendamentoAlertas", AActions, "spvwagendamentoalertas", ["alerta"], _AAction, AConditionsAND, []);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_ALERTAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch(changePreload())
                ])
            ).catch(error => {
                return dispatch({
                    type: ALERTAS_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_ALERTAS,
        payload: null,
    };
}

function changePreload() {
    return {
        type: ALERTAS_CHANGE_PRELOAD
    };
}